<template>
    <div class="the-build pt-4 px-4 md:px-0">
        <h1>Build</h1>
        <p class="mb-0">Version: {{ version }}</p>
        <p>VueVersion: {{ vueVersion }}</p>
        <p>Build time: {{ appBuildDateTime }}</p>
    </div>
</template>
<script>
import { appConstants } from '@utils/constants';
import { dateConstants } from '@utils/constants';
import dateFilter from '@/utils/date';

export default {
    name: 'Build',
    computed: {
        appBuildDateTime() {
            const buildTimetamp = appConstants.BUILD_TIMESTAMP;

            if (!buildTimetamp) return '';

            return dateFilter(new Date(buildTimetamp), dateConstants.TIMESTAMP);
        },
        version() {
            return appConstants.VERSION;
        },
        vueVersion() {
            return '3.1.0';
        },
    },
};
</script>
